import { AxiosResponse } from 'axios';

import { LabelsCategories, Labels } from '@/models/labels';

import { decomposeParams, api } from '.';

// Labels
export const getLabels = (
  params: Labels.Params
): Promise<AxiosResponse<Labels.Response>> =>
  api.get(`v2/labels/${decomposeParams(params)}`);

export const getLabel = (id: number): Promise<AxiosResponse<Labels.Detail>> =>
  api.get(`v2/labels/${id}`);

export const createLabels = (payload: { name: string }) =>
  api.post(`v2/labels/`, payload);

export const mergeLabels = (id: number, payload: { labelIds: number[] }) =>
  api.post(`v2/labels/${id}/merge`, payload);

export const assignLabelToPost = (
  id: number,
  postId: number,
  payload: { categoryId?: number }
) => api.post(`v2/labels/${id}/posts/${postId}`, payload);

export const updateLabels = (id: number, payload: { name: string }) =>
  api.put(`v2/labels/${id}`, payload);

export const deleteLabels = (id: number) => api.delete(`v2/labels/${id}`);

export const deleteLabelToPost = (
  id: number,
  postId: number,
  payload: { categoryId?: number }
) => api.delete(`v2/labels/${id}/posts/${postId}`, { data: payload });

// Categories
export const getCategories = (
  params: LabelsCategories.Params
): Promise<AxiosResponse<LabelsCategories.Response>> =>
  api.get(`v2/categories/${decomposeParams(params)}`);

export const getCategory = (
  id: number
): Promise<AxiosResponse<LabelsCategories.Detail>> =>
  api.get(`v2/categories/${id}`);

export const createCategory = (payload: { name: string }) =>
  api.post(`v2/categories/`, payload);

export const mergeCategories = (
  id: number,
  payload: { categoryIds: number[] }
) => api.post(`v2/categories/${id}/merge`, payload);

export const assignLabelToCategory = (id: number, labelId: number) =>
  api.post(`v2/categories/${id}/labels/${labelId}`);

export const updateCategories = (id: number, payload: { name: string }) =>
  api.put(`v2/categories/${id}`, payload);

export const updateLabelToCategory = (
  id: number,
  labelId: number,
  payload: { name: string }
) => api.put(`v2/categories/${id}/labels/${labelId}`, payload);

export const deleteCategories = (id: number) =>
  api.delete(`v2/categories/${id}`);

export const deleteLabelToCategory = (id: number, labelId: number) =>
  api.delete(`v2/categories/${id}/labels/${labelId}`);
